import script from "./WissenView.vue?vue&type=script&setup=true&lang=js"
export * from "./WissenView.vue?vue&type=script&setup=true&lang=js"

import "./WissenView.vue?vue&type=style&index=0&id=dac51cac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dac51cac"]])

export default __exports__